﻿import Vue from "vue";
import Component from "vue-class-component"
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import { IHotEditableFormParentVue } from "../../common";
import common = require("../../common");
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");

// The @Component decorator indicates the class is a Vue component
@Component
class PanneauAdministrationVue extends Vue implements IHotEditableFormParentVue {
    $initialData: any;

    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;

    // Statut de la synchro
    synchroStatusCode = null as string;
    synchroStatusDescription = null as string;
    synchroStatusIndicator = null as string;
    synchroSteps = [] as string[];
    maximumStepsToShow = 5;

    // Statut de la cache des fermes
    isFermeCacheReady = false;
    fermeCacheStatusDescription = null as string;
    fermeCacheReadyIndicator = null as string;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;

        HotEditableFormLoader.prepareComponentsMarkupFromTarget(true, false, rootId).loadComponentsFromParent(this);

        this.$options.el = '#' + rootId;

        const formName = (this as any).$initialData.formName || (() => { throw "[$initialData] La propriété 'formName' est NULL."; })();
        this.formManager = new HotEditableFormManager(this, formName);
        this.shared = new SharedHotEditableParentForm(this.formManager);
    }

    created() { }

    mounted() {
        for (let i = 0; i < this.maximumStepsToShow; i++)
            this.synchroSteps.push("");
    }

    // Défini le statut de la synchro à l'écran
    setSynchroStatus(code: string, description: string, currentStep: string) {
        this.synchroStatusCode = code;
        this.synchroStatusDescription = description;

        // Définir la couleur de l'indicateur
        if (code === common.TaskStatus.ok)
            this.synchroStatusIndicator = common.IndicatorStatus.ok;
        else if (code === common.TaskStatus.running || code === common.TaskStatus.runningLong)
            this.synchroStatusIndicator = common.IndicatorStatus.warning;
        else if (code === common.TaskStatus.inError || code === common.TaskStatus.jammed)
            this.synchroStatusIndicator = common.IndicatorStatus.error;
        else
            this.synchroStatusIndicator = common.IndicatorStatus.default;

        // Ajouter à l'écran le "step" courant de la synchro s'il est différent du dernier obtenu

        // Si le plus recent doit etre en dernier...
        // if (currentStep && currentStep !== this.synchroSteps[this.synchroSteps.length - 1]) {
        //     this.synchroSteps.push(currentStep);
        //     this.synchroSteps.shift();
        // }
        // Si le plus recent doit etre en premier...
        if (currentStep && currentStep !== this.synchroSteps[0]) {
            this.synchroSteps.splice(0, 0, currentStep);
            this.synchroSteps.pop();
        }
    }

    //------------------------------------------------------------------
    // Défini le statut de la cache des fermes à l'écran
    //------------------------------------------------------------------
    setFermeCacheStatus(isReady: boolean, description: string) {
        this.isFermeCacheReady = isReady;
        this.fermeCacheStatusDescription = description;

        // Définir la couleur de l'indicateur
        this.fermeCacheReadyIndicator = isReady
            ? common.IndicatorStatus.ok
            : common.IndicatorStatus.warning;
    }
}

export = PanneauAdministrationVue;